import React from "react";
import { makeStyles } from "@mui/styles";
import QueryContractNumberIconHighLight from "../../../../assets/home/insurance.png";
import QueryContractNumberIconDefault from "../../../../assets/home/insurance-default.png";
import QueryDoccumentNumberIconHighLight from "../../../../assets/home/card-high-light.png";
import QueryDoccumentNumberIconDefault from "../../../../assets/home/id-card.png";
import { colors } from "src/colors/colors";
import QueryInsuranceNumber from "../queryInsuranceNumber/queryInsuranceNumber";
import QueryDocumentNumber from "../queryDocumentNumber/queryDocumentNumber";
import parse from "html-react-parser";
import { FontSize } from "src/const/font";
const useStyles = makeStyles((theme) => {
  return {
    container: {
      display: "flex",
    },
    item: {
      width: "50%",
      ...theme.custom.flexBox.flexCenterCenter,
      padding: "10px 0 13px 0",
      lineHeight: "24px",
      fontWeight: 700,
      color: theme.custom.text.title,
      background: colors.white,
      borderTop: `2px solid ${colors.pinks.main}`,
      cursor: "pointer",
      [theme.breakpoints.down("md")]: {
        fontSize: FontSize.sub.default,
        lineHeight: "18px",
        padding: "8px",
      },
    },
    icon: {
      marginRight: "16px",
      width:"40px",
      [theme.breakpoints.down("md")]: {
        width: "20px",
      },
    },
    contentQuery: {
      background: colors.white,
      paddingTop: "24px",
    },
    contentQueryContainer: {
      width: "70%",
      margin: "0 auto",
      paddingBottom: "155px",
      [theme.breakpoints.down("lg")]: {
        width: "90%",
      },
      [theme.breakpoints.down("md")]: {
        width: "100%",
        paddingBottom: "0px",
      },
    },
  };
});
const highLightQuery = {
  borderTop: `2px solid #E0E0E0`,
  background: "#F5F5F5",
};

interface IProps {
  onNextStep: (e?: any) => void;
}

const QueryContract = (props: IProps) => {
  const { onNextStep } = props;
  //! State
  const [idQuery, setIdQuery] = React.useState(1);
  const classes = useStyles();
  const widthScreen = screen.width;
  return (
    <>
      <div className={classes.container}>
        {data.map((item) => {
          return (
            <div
              key={item.id}
              className={classes.item}
              style={idQuery !== item.id ? { ...highLightQuery } : {}}
              onClick={() => {
                setIdQuery(item.id);
              }}
            >
              <img src={idQuery === item.id ? item.iconHighlight : item.iconDefault} alt="" className={classes.icon} />
              {widthScreen > 600
                ? parse(`${item.title}`)
                : parse(`${item.titleMobei}`)}
            </div>
          );
        })}
      </div>
      <div className={classes.contentQuery}>
        <div className={classes.contentQueryContainer}>
          {idQuery === 1 ? (
            <QueryInsuranceNumber/>
          ) : (
            <QueryDocumentNumber/>
          )}
        </div>
      </div>
    </>
  );
};

export default QueryContract;
const data = [
  {
    id: 1,
    title: "Truy vấn theo Số Hợp đồng bảo hiểm",
    titleMobei: "Truy vấn theo<br>Số Hợp đồng bảo hiểm",
    iconHighlight: QueryContractNumberIconHighLight,
    iconDefault: QueryContractNumberIconDefault,
  },
  {
    id: 2,
    title: "Truy vấn theo Số giấy tờ tuỳ thân",
    titleMobei: "Truy vấn theo<br>Số giấy tờ tuỳ thân",
    iconDefault: QueryDoccumentNumberIconDefault,
    iconHighlight:QueryDoccumentNumberIconHighLight
  },
];
